import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { mediaQueries } from '../../constants/breakpoints';
import Button from '@mui/material/Button';
import { CheckGreenIcon, CheckGreyIcon } from '../../icons';
import { getData } from '../../modules/fetch';
import Popup from '../../components/Popup';
import ErrorIcon from '@mui/icons-material/Error';
import AvTimerIcon from '@mui/icons-material/AvTimer';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 24px 20px;
  @media ${mediaQueries.desktop} {
    margin: 24px 80px;
  }
`;

const SwitcherContainer = styled.div`
  display: flex;
  flex-direction: column;
  @media ${mediaQueries.desktop} {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
`;
const Text = styled.div`
  color: rgba(94, 88, 115, 1);
  font-size: 16px;

  margin-bottom: 20px;
  @media ${mediaQueries.desktop} {
    margin-bottom: 0;
    margin-top: 20px;
  }
`;
const InProgress = styled.div`
  display: flex;
  align-items: center;
  color: rgba(94, 88, 115, 1);
  font-size: 16px;

  margin-bottom: 20px;
  @media ${mediaQueries.desktop} {
    margin-bottom: 0;
    margin-top: 20px;
  }

  svg {
    margin-right: 10px;
  }
`;
const Error = styled.div`
  display: flex;
  align-items: center;
  color: rgba(94, 88, 115, 1);
  font-size: 16px;

  margin-bottom: 20px;
  @media ${mediaQueries.desktop} {
    margin-bottom: 0;
    margin-top: 20px;
  }

  svg {
    margin-right: 10px;
    color: #f00;
  }
`;
const CardsContainer = styled.div`
  display: flex;
  margin-top: 40px;
  justify-content: space-between;
  flex-direction: column;
  @media ${mediaQueries.desktop} {
    flex-direction: row;
  }
`;

const Card = styled.div`
  background-color: #fff;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  color: #000;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  position: relative;
  margin-bottom: 20px;
  @media ${mediaQueries.desktop} {
    min-width: 250px;
    margin-bottom: 0;
    margin-right: 20px;
    :last-child {
      margin-right: 0;
    }
  }
`;
const Title = styled.div`
  text-align: center;

  color: #000;
  font-size: 1rem;
  letter-spacing: 0.5px;
  margin-top: 20px;
`;
const Price = styled.div`
  flex: 104px 0 0;
  background: rgba(196, 196, 196, 0.15);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 18px;
`;
const Amount = styled.div`
  font-size: 40px;
  margin-bottom: 5px;
  font-weight: 500;
`;
const Per = styled.div`
  font-size: 1rem;
  letter-spacing: 0.5px;
`;
const List = styled.div`
  margin: 36px 32px 0 32px;
  flex-grow: 1;
`;
const ListItem = styled.div`
  font-size: 16px;

  display: flex;
  align-items: center;
  margin-bottom: 20px;

  svg {
    color: #7b8794;
    margin-right: 10px;
  }
`;
const Buttons = styled.div`
  display: flex;
  margin: 30px 32px 50px;
  justify-content: center;

  button {
    width: 100%;
  }
`;
const YellowButton = styled(Button)`
  background-color: #fc0 !important;
`;
const PopupButtons = styled.div`
  display: flex;
  margin: 30px 32px 30px;
  justify-content: center;

  button {
    margin: 0 10px;
  }
`;
const LinksContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 50px;
`;
const LinksTitle = styled.div`
  text-transform: uppercase;
  color: rgba(94, 88, 115, 1);
  font-weight: 500;
  text-decoration: underline;
`;
const Links = styled.div`
  display: flex;
  margin-top: 40px;
  flex-direction: column;
  @media ${mediaQueries.desktop} {
    flex-direction: row;
  }
`;
// const Link = styled.div<{ type: string }>`
const NavLink = styled(Link)`
  width: 170px;
  height: 108px;
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 4px 4px 20px rgba(0, 0, 0, 0.1);
  background-position: center 20px;
  background-repeat: no-repeat;
  color: rgba(196, 196, 196, 1);
  font-size: 1rem;
  letter-spacing: 0.5px;
  text-align: center;
  padding-top: 80px;
  text-transform: uppercase;
  font-weight: 500;
  margin: 0 20px 20px;
  cursor: pointer;
  ${(props) =>
          props.type === 'live-chat' &&
          `
    background-image: url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M23.75 7.5H8.75C8.06 7.5 7.5 8.06 7.5 8.75C7.5 9.44 8.06 10 8.75 10H23.75C24.44 10 25 9.44 25 8.75C25 8.06 24.44 7.5 23.75 7.5Z' fill='%23979797'/%3E%3Cpath d='M18.75 12.5H8.75C8.06 12.5 7.5 13.06 7.5 13.75C7.5 14.44 8.06 15 8.75 15H18.75C19.44 15 20 14.44 20 13.75C20 13.06 19.44 12.5 18.75 12.5Z' fill='%23979797'/%3E%3Cpath d='M27.5 0H5C2.2425 0 0 2.2425 0 5V30C0 30.485 0.28 30.9275 0.72 31.1325C0.8875 31.21 1.07 31.25 1.25 31.25C1.5375 31.25 1.8225 31.15 2.05 30.96L9.2025 25H27.5C30.2575 25 32.5 22.7575 32.5 20V5C32.5 2.2425 30.2575 0 27.5 0ZM30 20C30 21.3775 28.88 22.5 27.5 22.5H8.75C8.4575 22.5 8.175 22.6025 7.95 22.79L2.5 27.3325V5C2.5 3.6225 3.62 2.5 5 2.5H27.5C28.88 2.5 30 3.6225 30 5V20Z' fill='%23979797'/%3E%3Cpath d='M35 10C34.31 10 33.75 10.56 33.75 11.25C33.75 11.94 34.31 12.5 35 12.5C36.38 12.5 37.5 13.6225 37.5 15V36.1475L33.28 32.7725C33.06 32.5975 32.7825 32.5 32.5 32.5H15C13.62 32.5 12.5 31.3775 12.5 30V28.75C12.5 28.06 11.94 27.5 11.25 27.5C10.56 27.5 10 28.06 10 28.75V30C10 32.7575 12.2425 35 15 35H32.06L37.9675 39.7275C38.195 39.9075 38.4725 40 38.75 40C38.9325 40 39.1175 39.96 39.2925 39.8775C39.725 39.6675 40 39.23 40 38.75V15C40 12.2425 37.7575 10 35 10Z' fill='%23979797'/%3E%3C/svg%3E%0A");
  `};
  ${(props) =>
          props.type === 'faqs' &&
          `
    background-image: url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0)'%3E%3Cpath d='M39.8426 36.2231L37.0966 28.2315C38.4174 25.5616 39.1159 22.5858 39.1206 19.5914C39.1286 14.435 37.1335 9.55931 33.5027 5.86275C29.8714 2.16549 25.0324 0.084404 19.8773 0.00260725C17.1765 -0.040752 14.5557 0.456903 12.0838 1.4801C9.69971 2.46706 7.56166 3.89666 5.72917 5.72916C3.89659 7.56166 2.46699 9.6997 1.48011 12.0838C0.456912 14.5557 -0.0401963 17.1778 0.00253801 19.8773C0.0841785 25.0324 2.16535 29.8714 5.86261 33.5028C9.55197 37.1264 14.4151 39.1209 19.5604 39.1208C19.5705 39.1208 19.5811 39.1208 19.5912 39.1208C22.5855 39.1161 25.5614 38.4176 28.2313 37.0968L36.2229 39.8428C36.5303 39.9485 36.8453 40 37.1568 40C37.897 40 38.617 39.7092 39.1629 39.1631C39.9386 38.3874 40.1992 37.2608 39.8426 36.2231ZM37.486 37.4862C37.4073 37.5649 37.2389 37.6843 36.9935 37.6L28.5252 34.6902C28.4 34.6472 28.2698 34.6258 28.1399 34.6258C27.9485 34.6258 27.758 34.6722 27.5854 34.7635C25.138 36.0582 22.3723 36.745 19.5874 36.7492C10.2476 36.7643 2.52167 29.1781 2.37371 19.8398C2.29925 15.1414 4.08644 10.7257 7.40604 7.40611C10.7256 4.08658 15.14 2.29971 19.8397 2.37401C29.178 2.52206 36.7635 10.2442 36.749 19.5877C36.7446 22.3727 36.0579 25.1383 34.7633 27.5856C34.61 27.8753 34.5835 28.2155 34.69 28.5254L37.5998 36.9937C37.6841 37.2389 37.5647 37.4076 37.486 37.4862Z' fill='%23979797'/%3E%3Cpath d='M19.3684 28.3398C18.7482 28.3398 18.154 28.8852 18.1826 29.5256C18.2114 30.168 18.7037 30.7114 19.3684 30.7114C19.9887 30.7114 20.5829 30.166 20.5542 29.5256C20.5255 28.8831 20.0332 28.3398 19.3684 28.3398Z' fill='%23979797'/%3E%3Cpath d='M19.3684 9.97461C16.1153 9.97461 13.4688 12.6212 13.4688 15.8742C13.4688 16.529 13.9997 17.06 14.6545 17.06C15.3094 17.06 15.8403 16.529 15.8403 15.8742C15.8403 13.9289 17.423 12.3462 19.3684 12.3462C21.3137 12.3462 22.8964 13.9289 22.8964 15.8742C22.8964 17.8195 21.3137 19.4022 19.3684 19.4022C18.7135 19.4022 18.1826 19.9332 18.1826 20.588V25.4243C18.1826 26.0792 18.7135 26.6101 19.3684 26.6101C20.0232 26.6101 20.5541 26.0793 20.5541 25.4243V21.654C23.2408 21.1037 25.268 18.7212 25.268 15.8742C25.268 12.6212 22.6214 9.97461 19.3684 9.97461Z' fill='%23979797'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0'%3E%3Crect width='40' height='40' fill='white'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A");
  `};
  ${(props) =>
          props.type === 'web-page' &&
          `
    background-image: url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M35.4589 37.6145H4.54106C2.03729 37.6145 0 35.5772 0 33.0734V6.8604C0 4.35662 2.03729 2.31934 4.54106 2.31934H35.4589C37.9627 2.31934 40 4.35662 40 6.8604V33.0734C40 35.5772 37.9627 37.6145 35.4589 37.6145ZM4.54106 3.67199C2.78306 3.67199 1.35266 5.1024 1.35266 6.8604V33.0734C1.35266 34.8314 2.78306 36.2618 4.54106 36.2618H35.4589C37.2169 36.2618 38.6473 34.8314 38.6473 33.0734V6.8604C38.6473 5.1024 37.2169 3.67199 35.4589 3.67199H4.54106Z' fill='%23979797'/%3E%3Cpath d='M33.8958 27.2882H23.2681C22.8945 27.2882 22.5918 26.9855 22.5918 26.6119C22.5918 26.2386 22.8945 25.9355 23.2681 25.9355H33.8958C34.269 25.9355 34.5721 26.2386 34.5721 26.6119C34.5721 26.9855 34.2694 27.2882 33.8958 27.2882Z' fill='%23979797'/%3E%3Cpath d='M33.8958 32.1779H23.2681C22.8945 32.1779 22.5918 31.8752 22.5918 31.5015C22.5918 31.1283 22.8945 30.8252 23.2681 30.8252H33.8958C34.269 30.8252 34.5721 31.1283 34.5721 31.5015C34.5721 31.8752 34.2694 32.1779 33.8958 32.1779Z' fill='%23979797'/%3E%3Cpath d='M33.8958 17.5089H23.2681C22.8945 17.5089 22.5918 17.2062 22.5918 16.8326C22.5918 16.4593 22.8945 16.1562 23.2681 16.1562H33.8958C34.269 16.1562 34.5721 16.4593 34.5721 16.8326C34.5721 17.2062 34.2694 17.5089 33.8958 17.5089Z' fill='%23979797'/%3E%3Cpath d='M33.8958 22.3986H23.2681C22.8945 22.3986 22.5918 22.0959 22.5918 21.7222C22.5918 21.349 22.8945 21.0459 23.2681 21.0459H33.8958C34.269 21.0459 34.5721 21.349 34.5721 21.7222C34.5721 22.0959 34.2694 22.3986 33.8958 22.3986Z' fill='%23979797'/%3E%3Cpath d='M39.3237 11.3751H0.676328C0.302687 11.3751 0 11.0724 0 10.6988C0 10.3251 0.302687 10.0225 0.676328 10.0225H39.3237C39.6973 10.0225 40 10.3251 40 10.6988C40 11.0724 39.6973 11.3751 39.3237 11.3751Z' fill='%23979797'/%3E%3Cpath d='M9.74937 8.9648C8.58882 8.9648 7.64453 8.02088 7.64453 6.86033C7.64453 5.69978 8.58882 4.75586 9.74937 4.75586C10.9099 4.75586 11.8538 5.69978 11.8538 6.86033C11.8538 8.02088 10.9099 8.9648 9.74937 8.9648ZM9.74937 6.10852C9.3346 6.10852 8.99719 6.44593 8.99719 6.86033C8.99719 7.27473 9.3346 7.61214 9.74937 7.61214C10.1638 7.61214 10.5012 7.27473 10.5012 6.86033C10.5012 6.44593 10.1638 6.10852 9.74937 6.10852Z' fill='%23979797'/%3E%3Cpath d='M4.87791 8.9648C3.71773 8.9648 2.77344 8.02088 2.77344 6.86033C2.77344 5.69978 3.71773 4.75586 4.87791 4.75586C6.03846 4.75586 6.98275 5.69978 6.98275 6.86033C6.98275 8.02088 6.03846 8.9648 4.87791 8.9648ZM4.87791 6.10852C4.4635 6.10852 4.12609 6.44593 4.12609 6.86033C4.12609 7.27473 4.4635 7.61214 4.87791 7.61214C5.29269 7.61214 5.6301 7.27473 5.6301 6.86033C5.6301 6.44593 5.29269 6.10852 4.87791 6.10852Z' fill='%23979797'/%3E%3Cpath d='M14.622 8.9648C13.4615 8.9648 12.5176 8.02088 12.5176 6.86033C12.5176 5.69978 13.4615 4.75586 14.622 4.75586C15.7826 4.75586 16.7269 5.69978 16.7269 6.86033C16.7269 8.02088 15.7826 8.9648 14.622 8.9648ZM14.622 6.10852C14.2073 6.10852 13.8702 6.44593 13.8702 6.86033C13.8702 7.27473 14.2076 7.61214 14.622 7.61214C15.0368 7.61214 15.3742 7.27473 15.3742 6.86033C15.3742 6.44593 15.0368 6.10852 14.622 6.10852Z' fill='%23979797'/%3E%3Cpath d='M18.1637 32.1783H5.89313C5.51948 32.1783 5.2168 31.8756 5.2168 31.502V16.8326C5.2168 16.4593 5.51948 16.1562 5.89313 16.1562H18.1637C18.5373 16.1562 18.84 16.4593 18.84 16.8326V31.502C18.84 31.8756 18.5373 32.1783 18.1637 32.1783ZM6.56945 30.8256H17.4873V17.5089H6.56945V30.8256Z' fill='%23979797'/%3E%3C/svg%3E%0A");
  `};
  ${(props) =>
          props.type === 'usage-guides' &&
          `
    background-image: url("data:image/svg+xml,%3Csvg width='41' height='41' viewBox='0 0 41 41' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8.04688 34.5938H32.9512C35.6005 34.5938 37.7559 32.4384 37.7559 29.7891V4.80469C37.7559 2.15538 35.6005 0 32.9512 0H8.04688C5.39757 0 3.24219 2.15538 3.24219 4.80469V36.1953C3.24219 38.8446 5.39757 41 8.04688 41H31.3496H32.9512C35.6005 41 37.7559 38.8446 37.7559 36.1953V36.1913C36.4166 37.1989 34.7524 37.7969 32.9512 37.7969H31.3496H8.04688C7.16377 37.7969 6.44531 37.0784 6.44531 36.1953C6.44531 35.3122 7.16377 34.5938 8.04688 34.5938ZM6.44531 4.80469C6.44531 3.92159 7.16377 3.20312 8.04688 3.20312H32.9512C33.8343 3.20312 34.5527 3.92159 34.5527 4.80469V29.7891C34.5527 30.6722 33.8343 31.3906 32.9512 31.3906H8.04688C7.48561 31.3906 6.94644 31.4874 6.44531 31.6651V4.80469ZM17.8164 13.4996H14.6133C14.6133 11.8565 15.3175 10.2839 16.5454 9.18464C17.7894 8.07091 19.4629 7.53855 21.1371 7.7245C23.8191 8.02215 25.9788 10.1762 26.2724 12.8466C26.5401 15.2821 25.1118 17.0297 24.0142 18.1324C23.7317 18.4162 23.471 18.6649 23.2409 18.8843C22.1944 19.8824 22.061 20.0503 22.061 20.7399V20.8203H18.8579V20.7398C18.8579 18.638 19.8646 17.678 21.0303 16.5662C21.2568 16.3503 21.491 16.1269 21.7441 15.8727C22.7784 14.8335 23.1805 14.0332 23.0886 13.1966C22.9574 12.0042 21.9882 11.0417 20.7839 10.9081C20.0034 10.8218 19.2565 11.0569 18.6819 11.5713C18.1237 12.0708 17.8164 12.7556 17.8164 13.4996ZM18.8574 23.2227H22.0605V26.4258H18.8574V23.2227Z' fill='%23979797'/%3E%3C/svg%3E%0A");
  `};
`;
const SimpleLink = styled.a`
  width: 170px;
  height: 108px;
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 4px 4px 20px rgba(0, 0, 0, 0.1);
  background-position: center 20px;
  background-repeat: no-repeat;
  color: rgba(196, 196, 196, 1);
  font-size: 1rem;
  letter-spacing: 0.5px;
  text-align: center;
  padding-top: 80px;
  text-transform: uppercase;
  font-weight: 500;
  margin: 0 20px 20px;
  cursor: pointer;
  background-image: url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M35.4589 37.6145H4.54106C2.03729 37.6145 0 35.5772 0 33.0734V6.8604C0 4.35662 2.03729 2.31934 4.54106 2.31934H35.4589C37.9627 2.31934 40 4.35662 40 6.8604V33.0734C40 35.5772 37.9627 37.6145 35.4589 37.6145ZM4.54106 3.67199C2.78306 3.67199 1.35266 5.1024 1.35266 6.8604V33.0734C1.35266 34.8314 2.78306 36.2618 4.54106 36.2618H35.4589C37.2169 36.2618 38.6473 34.8314 38.6473 33.0734V6.8604C38.6473 5.1024 37.2169 3.67199 35.4589 3.67199H4.54106Z' fill='%23979797'/%3E%3Cpath d='M33.8958 27.2882H23.2681C22.8945 27.2882 22.5918 26.9855 22.5918 26.6119C22.5918 26.2386 22.8945 25.9355 23.2681 25.9355H33.8958C34.269 25.9355 34.5721 26.2386 34.5721 26.6119C34.5721 26.9855 34.2694 27.2882 33.8958 27.2882Z' fill='%23979797'/%3E%3Cpath d='M33.8958 32.1779H23.2681C22.8945 32.1779 22.5918 31.8752 22.5918 31.5015C22.5918 31.1283 22.8945 30.8252 23.2681 30.8252H33.8958C34.269 30.8252 34.5721 31.1283 34.5721 31.5015C34.5721 31.8752 34.2694 32.1779 33.8958 32.1779Z' fill='%23979797'/%3E%3Cpath d='M33.8958 17.5089H23.2681C22.8945 17.5089 22.5918 17.2062 22.5918 16.8326C22.5918 16.4593 22.8945 16.1562 23.2681 16.1562H33.8958C34.269 16.1562 34.5721 16.4593 34.5721 16.8326C34.5721 17.2062 34.2694 17.5089 33.8958 17.5089Z' fill='%23979797'/%3E%3Cpath d='M33.8958 22.3986H23.2681C22.8945 22.3986 22.5918 22.0959 22.5918 21.7222C22.5918 21.349 22.8945 21.0459 23.2681 21.0459H33.8958C34.269 21.0459 34.5721 21.349 34.5721 21.7222C34.5721 22.0959 34.2694 22.3986 33.8958 22.3986Z' fill='%23979797'/%3E%3Cpath d='M39.3237 11.3751H0.676328C0.302687 11.3751 0 11.0724 0 10.6988C0 10.3251 0.302687 10.0225 0.676328 10.0225H39.3237C39.6973 10.0225 40 10.3251 40 10.6988C40 11.0724 39.6973 11.3751 39.3237 11.3751Z' fill='%23979797'/%3E%3Cpath d='M9.74937 8.9648C8.58882 8.9648 7.64453 8.02088 7.64453 6.86033C7.64453 5.69978 8.58882 4.75586 9.74937 4.75586C10.9099 4.75586 11.8538 5.69978 11.8538 6.86033C11.8538 8.02088 10.9099 8.9648 9.74937 8.9648ZM9.74937 6.10852C9.3346 6.10852 8.99719 6.44593 8.99719 6.86033C8.99719 7.27473 9.3346 7.61214 9.74937 7.61214C10.1638 7.61214 10.5012 7.27473 10.5012 6.86033C10.5012 6.44593 10.1638 6.10852 9.74937 6.10852Z' fill='%23979797'/%3E%3Cpath d='M4.87791 8.9648C3.71773 8.9648 2.77344 8.02088 2.77344 6.86033C2.77344 5.69978 3.71773 4.75586 4.87791 4.75586C6.03846 4.75586 6.98275 5.69978 6.98275 6.86033C6.98275 8.02088 6.03846 8.9648 4.87791 8.9648ZM4.87791 6.10852C4.4635 6.10852 4.12609 6.44593 4.12609 6.86033C4.12609 7.27473 4.4635 7.61214 4.87791 7.61214C5.29269 7.61214 5.6301 7.27473 5.6301 6.86033C5.6301 6.44593 5.29269 6.10852 4.87791 6.10852Z' fill='%23979797'/%3E%3Cpath d='M14.622 8.9648C13.4615 8.9648 12.5176 8.02088 12.5176 6.86033C12.5176 5.69978 13.4615 4.75586 14.622 4.75586C15.7826 4.75586 16.7269 5.69978 16.7269 6.86033C16.7269 8.02088 15.7826 8.9648 14.622 8.9648ZM14.622 6.10852C14.2073 6.10852 13.8702 6.44593 13.8702 6.86033C13.8702 7.27473 14.2076 7.61214 14.622 7.61214C15.0368 7.61214 15.3742 7.27473 15.3742 6.86033C15.3742 6.44593 15.0368 6.10852 14.622 6.10852Z' fill='%23979797'/%3E%3Cpath d='M18.1637 32.1783H5.89313C5.51948 32.1783 5.2168 31.8756 5.2168 31.502V16.8326C5.2168 16.4593 5.51948 16.1562 5.89313 16.1562H18.1637C18.5373 16.1562 18.84 16.4593 18.84 16.8326V31.502C18.84 31.8756 18.5373 32.1783 18.1637 32.1783ZM6.56945 30.8256H17.4873V17.5089H6.56945V30.8256Z' fill='%23979797'/%3E%3C/svg%3E%0A");
`;

const CurrentPlan = ({ userData }) => {
  const [plans, setPlans] = useState([]);
  const [currentUser, setCurrentUser] = useState<any>();
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const [newPlanID, setNewPlanID] = useState(false);
  const [paymentError, setPaymentError] = useState(false);
  const [paymentInProgress, setPaymentInProgress] = useState(false);

  useEffect(() => {
    if (userData === undefined || userData === null) {
      return;
    }
    setCurrentUser(userData);
    if (userData?.subscriptionProcessStatus === 'canceled') {
      setPaymentError(true);
    }
    if (userData?.subscriptionProcessStatus === 'in_progress') {
      setPaymentInProgress(true);
    }
    if (userData?.nextSubscriptionId) {
      setNewPlanID(userData.nextSubscriptionId);
    }
  }, [userData]);

  useEffect(() => {
    getData('/subscriptions/listings')
      .then((data) => {
        if (data)
          setPlans(data.data);
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);

  const handleClosePopup = () => {
    setShowConfirmPopup(false);
    setNewPlanID(false);
  };

  const changePlan = (id) => {
    setNewPlanID(id);
    if (currentUser.subscriptionStatus === 'active' && currentUser.subscriptionId !== '') {
      setShowConfirmPopup(true);
    } else {
      confirmPlan();
    }
  };

  const confirmPlan = () => {
    getData(`/subscriptions/stripe/checkout/${newPlanID}`)
      .then(() => {
        setShowConfirmPopup(false);
        setPaymentInProgress(true);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  return (
    <>
      {showConfirmPopup && (
        <Popup
          isPreviewTicket={false}
          setIsPreviewTicket={() => {
          }}
          handleClose={handleClosePopup}
        >
          <>
            <Title>
              <FormattedMessage
                id="settings.currentPlan.popup.title"
                defaultMessage="Are you sure you want to change your subscription plan from"
              />
              <strong>
                {' '}
                <FormattedMessage
                  id={plans.find((plan) => plan?._id.$oid === currentUser.subscriptionId).name}
                  defaultMessage={
                    plans.find((plan) => plan?._id.$oid === currentUser.subscriptionId).name
                  }
                />
              </strong>{' '}
              <FormattedMessage id="settings.currentPlan.popup.title" defaultMessage="to" />
              <strong>
                <FormattedMessage
                  id={plans.find((plan) => plan._id.$oid === newPlanID).name}
                  defaultMessage={plans.find((plan) => plan._id.$oid === newPlanID).name}
                />
              </strong>{' '}
              ?
            </Title>
            <PopupButtons>
              <Button onClick={handleClosePopup}>
                <FormattedMessage
                  id="settings.currentPlan.popup.button_cancel"
                  defaultMessage="Cancel"
                />
              </Button>
              <Button size="large" variant="contained" color="primary" onClick={confirmPlan}>
                <FormattedMessage
                  id="settings.currentPlan.popup.button_change"
                  defaultMessage="Change Plan"
                />
              </Button>
            </PopupButtons>
          </>
        </Popup>
      )}
      <Container>
        <SwitcherContainer>
          <Text>
            <FormattedMessage
              id="settings.currentPlan.switcher"
              defaultMessage="Pick an account plan that fits your workflow"
            />
          </Text>
        </SwitcherContainer>
        {paymentInProgress && (
          <InProgress>
            <AvTimerIcon />
            <FormattedMessage
              id="settings.currentPlan.inProgress"
              defaultMessage="Please, be patient. Your payment is being proceed"
            />
          </InProgress>
        )}
        {paymentError && (
          <Error>
            <ErrorIcon />
            <FormattedMessage
              id="settings.currentPlan.error"
              defaultMessage="Your payment has been declined. Please try again."
            />
          </Error>
        )}

        <CardsContainer key={`plans-cards-${Math.random()}`}>
          {currentUser &&
            plans.map((plan) =>
                plan.type !== 'top_up' && (
                  <Card key={`plan-card-${plan?._id?.$oid}-${Math.random()}`}>
                    <Title>
                      <FormattedMessage id={plan.name} defaultMessage={plan.name} />
                    </Title>
                    <Price>
                      <Amount>
                        <FormattedMessage
                          id={plan.subscriptionTitle}
                          defaultMessage={plan.subscriptionTitle}
                        />
                      </Amount>
                      <Per>
                    <span>
                      <FormattedMessage
                        id="settings.currentPlan.per_month"
                        defaultMessage="per month"
                      />
                    </span>
                      </Per>
                    </Price>
                    <List>
                      {plan.descriptionItems.map((item) => (
                        <ListItem>
                          {item.selected ? <CheckGreenIcon /> : <CheckGreyIcon />}
                          <FormattedMessage id={item.label} defaultMessage={item.label} />
                        </ListItem>
                      ))}
                    </List>
                    <Buttons>
                      {currentUser?.subscriptionStatus === 'active' &&
                      currentUser?.subscriptionId === plan._id.$oid ? (
                        <Button size="large" variant="contained">
                          <FormattedMessage
                            id="settings.currentPlan.button_plan"
                            defaultMessage="Current plan"
                          />
                        </Button>
                      ) : (
                        <>
                          {newPlanID && newPlanID === plan._id.$oid ? (
                            <YellowButton size="large" variant="contained">
                              <FormattedMessage
                                id="settings.currentPlan.button_payment"
                                defaultMessage="Payment pending"
                              />
                            </YellowButton>
                          ) : (
                            <Button
                              size="large"
                              variant="contained"
                              color="primary"
                              onClick={() => changePlan(plan._id.$oid)}
                            >
                              <FormattedMessage
                                id="settings.currentPlan.button_upgrade"
                                defaultMessage="Upgrade plan"
                              />
                            </Button>
                          )}
                        </>
                      )}
                    </Buttons>
                  </Card>
                )
            )}
        </CardsContainer>

        <LinksContainer>
          <LinksTitle>
            <FormattedMessage
              id="settings.currentPlan.links.title"
              defaultMessage="Any questions left?"
            />
          </LinksTitle>
          <Links>
            <NavLink type="live-chat" to="/support/chat">
              <FormattedMessage id="settings.currentPlan.links.chat" defaultMessage="Live chat" />
            </NavLink>
            <NavLink type="faqs" to="/support/faq">
              <FormattedMessage id="settings.currentPlan.links.faq" defaultMessage="FAQs" />
            </NavLink>
            <SimpleLink href="https://omcom.io" target="_blank">
              <FormattedMessage id="settings.currentPlan.links.page" defaultMessage="Web page" />
            </SimpleLink>
          </Links>
        </LinksContainer>
      </Container>
    </>
  );
};

export default CurrentPlan;
